import { h, VNode } from 'preact';
import './style.scss';
import RadioButton from '../RadioButton';
import { AssistReason } from '../../types';
import TextArea from '../TextArea';

type Props = {
  options: AssistReason[];
  current: string;
  onChange: (name: string) => void;
  onChangeComment: ({ target }: { target: EventTarget }) => void;
};

const RadioGroup = ({ options, current, onChange, onChangeComment }: Props) => {
  const renderItem = ({ label, value, placeholder, description }: AssistReason, index: number): VNode => (
    <div className="option_ta" key={index}>
      <RadioButton checked={value === current} label={label} name={value} value={value} onChange={onChange} />
      {value === current ? (
        <div className="bottom_ta">
          <div>
            <TextArea onChange={onChangeComment} placeholder={placeholder} />
            <div className="description_ta">{description}</div>
          </div>
        </div>
      ) : null}
    </div>
  );

  return <div className="radio-group_ta">{options.map(renderItem)}</div>;
};

export default RadioGroup;
